import { ContainerInfo, Text, Value } from './style'

const InfoWrap = ({ text, value, cursor, bgColor }) => {
  return (
    <ContainerInfo cursor={cursor}>
      <Value bgColor={bgColor}>{value}</Value>
      <Text>{text}</Text>
    </ContainerInfo>
  )
}
export default InfoWrap
